import React from 'react';

import Shimmer from 'components/Shimmer';

import { Item, TravelInfo, InfoContainer, Info, Title, TravelCardHeader, Container, UserLabel } from './styles';

const LoaderCard = () => (
  <Item>
    <Container style={{ height: 159 }}>
      <TravelCardHeader>
        <TravelInfo>
          <Shimmer>Code: 123456789</Shimmer>
        </TravelInfo>
        <Shimmer>Approved</Shimmer>
      </TravelCardHeader>
      <Title>
        <Shimmer>Renta de auto en New York</Shimmer>
      </Title>
      <InfoContainer>
        <Info>
          <Shimmer>01/01/21</Shimmer> <Shimmer>10/01/21</Shimmer>
        </Info>
        <Info>
          <Shimmer>Traveler name</Shimmer>
          <UserLabel>
            <Shimmer width="16" height="16" />
            <Shimmer>Group Users</Shimmer>
          </UserLabel>
        </Info>
      </InfoContainer>
    </Container>
  </Item>
);
export default LoaderCard;
